<!-- eslint-disable max-len -->
<template>
  <div>
    <!-- TEXT STYLES -->
    <section>
      <b-row>
        <div class="col-2">
          <div class="left-content">
            <p class="xxs bold text-right">
              TEXT STYLES
            </p>
          </div>
        </div>
        <div class="col-10 bg-pale-grey-two">
          <div class="right-content">
            <b-row>
              <div class="col-5">
                <p class="bold">
                  h1
                </p>
                <h1>Kariyer.net Regular 22px/32px</h1>
              </div>
              <div class="col-5">
                <p class="bold">
                  h1
                </p>
                <h1 class="bold">
                  Kariyer.net Bold 22px/32px
                </h1>
              </div>
            </b-row>
            <hr>

            <b-row>
              <div class="col-5">
                <p class="bold">
                  h2
                </p>
                <h2>Kariyer.net Regular 20px/30px</h2>
              </div>
              <div class="col-5">
                <p class="bold">
                  h2
                </p>
                <h2 class="bold">
                  Kariyer.net Bold 20px/30px
                </h2>
              </div>
            </b-row>
            <hr>

            <b-row>
              <div class="col-5">
                <p class="bold">
                  .lg
                </p>
                <p class="lg">
                  Kariyer.net Regular 16px/24px
                </p>
              </div>
              <div class="col-5">
                <p class="bold">
                  .lg
                </p>
                <p class="lg bold">
                  Kariyer.net Regular 16px/24px
                </p>
              </div>
            </b-row>
            <hr>

            <b-row>
              <div class="col-5">
                <p class="bold">
                  .md
                </p>
                <p class="md">
                  KARİYER.NET REGULAR 14px/22px
                </p>
              </div>
              <div class="col-5">
                <p class="bold">
                  .xxs
                </p>
                <p class="xxs bold">
                  KARİYER.NET BOLD 14px/22px
                </p>
              </div>
            </b-row>

            <hr>

            <b-row>
              <div class="col-5">
                <p class="bold">
                  .sm
                </p>
                <p class="sm">
                  Kariyer.net Regular 13px/20px
                </p>
              </div>
              <div class="col-5">
                <p class="bold">
                  .sm
                </p>
                <p class="sm">
                  Kariyer.net Bold 13px/20px
                </p>
              </div>
            </b-row>
            <hr>

            <b-row>
              <div class="col-5">
                <p class="bold">
                  .xs
                </p>
                <p class="xs">
                  Kariyer.net Regular 12px/18px
                </p>
              </div>
              <div class="col-5">
                <p class="bold">
                  .xs
                </p>
                <p class="xs">
                  Kariyer.net Bold 12px/18px
                </p>
              </div>
            </b-row>
            <hr>

            <b-row>
              <div class="col-5">
                <p class="bold">
                  .xxs
                </p>
                <p class="xxs">
                  KARİYER.NET REGULAR 10px/16px
                </p>
              </div>
              <div class="col-5">
                <p class="bold">
                  .xxs
                </p>
                <p class="xxs bold">
                  KARİYER.NET BOLD 10px/16px
                </p>
              </div>
            </b-row>
            <hr>

            <b-row>
              <div class="col-5">
                <p class="bold">
                  paragraph regular 14px/22px
                </p>
                <p>
                  Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law.
                </p>
              </div>
              <div class="col-5">
                <p class="bold">
                  paragraph bold 14px/22px
                </p>
                <p class="bold">
                  Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law.
                </p>
              </div>
            </b-row>
          </div>
        </div>
      </b-row>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Text',
  data() {
    return {};
  },
  computed: {},
};
</script>
